import GameTypeSelect from './GameTypeSelect';

export default GameTypeSelect;
